import './post.scss'

import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '../global'

const TagsContainer = ({ tags }) => {
  if (tags.length === 0) return null

  return (
    <div className="tags-container">
      {tags.slice(0, 6).map(({ uri, name }, idx) => {
        return (
          <Link to={uri} className="post-tag" key={idx}>
            {name}
          </Link>
        )
      })}
    </div>
  )
}

TagsContainer.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({ uri: PropTypes.string, name: PropTypes.string }),
  ),
}

export default TagsContainer
